import { __decorate, __metadata } from 'tslib';
import { EventEmitter, NgZone, ViewChild, ElementRef, Input, Output, Component, forwardRef, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';

const _c0 = ["easyMarkDownEditor"];
class EasymdeConfig {
}

var EasymdeComponent_1;
let EasymdeComponent = EasymdeComponent_1 = class EasymdeComponent {
    constructor(cog, zone) {
        this.cog = cog;
        this.zone = zone;
        this.onChange = new EventEmitter();
        this.onBlur = new EventEmitter();
        cog = Object.assign(Object.assign({}, new EasymdeConfig()), cog);
        this.style = cog.style;
        this.delay = cog.delay || 0;
    }
    get Instance() {
        return this.instance;
    }
    /**
     * Call [setOption](https://codemirror.net/doc/manual.html#setOption) method
     * of Codemirror.
     */
    setOptions(option, value) {
        if (!this.instance)
            return;
        this.instance.codemirror.setOption(option, value);
    }
    registerOnChange(fn) {
        if (this.instance) {
            this.instance.codemirror.on('change', fn);
        }
        else {
            setTimeout(() => this.instance.codemirror.on('change', fn), 1000);
        }
    }
    registerOnTouched(fn) {
        if (this.instance) {
            this.instance.codemirror.on('blur', fn);
        }
        else {
            setTimeout(() => this.instance.codemirror.on('blur', fn), 1000);
        }
    }
    initDelay() {
        if (this.delay > 0) {
            setTimeout(() => this.init(), this.delay);
        }
        else {
            this.init();
        }
    }
    init() {
        if (typeof EasyMDE === 'undefined') {
            throw new Error(`Could not find EasyMDE object.`);
        }
        this.destroy();
        const config = Object.assign({}, this.cog, this.options, this.style === 'default'
            ? {
                spellChecker: true,
                autoDownloadFontAwesome: false,
            }
            : {});
        config.element = this.con.nativeElement;
        this.zone.runOutsideAngular(() => {
            this.instance = new EasyMDE(config);
            if (this.value) {
                this.instance.value(this.value);
            }
            this.instance.codemirror.on('blur', () => {
                this.value = this.instance.value();
                this.zone.run(() => {
                    this.onBlur.emit(this.value);
                });
            });
            this.instance.codemirror.on('change', () => {
                this.value = this.instance.value();
                this.zone.run(() => {
                    this.onChange.emit(this.value);
                });
            });
            this.setDisable();
        });
    }
    destroy() {
        if (this.instance) {
            this.instance.toTextArea();
            this.instance = null;
        }
    }
    setDisable() {
        if (this.instance) {
            this.zone.runOutsideAngular(() => (this.instance.codemirror.options.readOnly = this.disabled));
        }
    }
    ngAfterViewInit() {
        this.initDelay();
    }
    ngOnChanges(changes) {
        if (changes.options && !changes.options.firstChange)
            this.initDelay();
    }
    ngOnDestroy() {
        this.destroy();
    }
    writeValue(value) {
        this.value = value;
        if (this.instance) {
            this.instance.value(this.value);
        }
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.setDisable();
    }
};
EasymdeComponent.ɵfac = function EasymdeComponent_Factory(t) { return new (t || EasymdeComponent)(ɵngcc0.ɵɵdirectiveInject(EasymdeConfig), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
EasymdeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: EasymdeComponent, selectors: [["easymde"]], viewQuery: function EasymdeComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.con = _t.first);
    } }, inputs: { style: "style", delay: "delay", disabled: "disabled", options: "options" }, outputs: { onChange: "onChange", onBlur: "onBlur" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => EasymdeComponent_1),
                multi: true
            },
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 0, consts: [["easyMarkDownEditor", ""]], template: function EasymdeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "textarea", null, 0);
    } }, encapsulation: 2, changeDetection: 0 });
EasymdeComponent.ctorParameters = () => [
    { type: EasymdeConfig },
    { type: NgZone }
];
__decorate([
    ViewChild('easyMarkDownEditor'),
    __metadata("design:type", ElementRef)
], EasymdeComponent.prototype, "con", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], EasymdeComponent.prototype, "options", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], EasymdeComponent.prototype, "style", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], EasymdeComponent.prototype, "delay", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], EasymdeComponent.prototype, "disabled", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], EasymdeComponent.prototype, "onChange", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], EasymdeComponent.prototype, "onBlur", void 0);
EasymdeComponent = EasymdeComponent_1 = __decorate([ __metadata("design:paramtypes", [EasymdeConfig, NgZone])
], EasymdeComponent);

var EasymdeModule_1;
let EasymdeModule = EasymdeModule_1 = class EasymdeModule {
    static forRoot(config) {
        return {
            ngModule: EasymdeModule_1,
            providers: [{ provide: EasymdeConfig, useValue: config }],
        };
    }
};
EasymdeModule.ɵfac = function EasymdeModule_Factory(t) { return new (t || EasymdeModule)(); };
EasymdeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: EasymdeModule });
EasymdeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EasymdeComponent, [{
        type: Component,
        args: [{
                selector: 'easymde',
                template: ` <textarea #easyMarkDownEditor></textarea> `,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => EasymdeComponent_1),
                        multi: true
                    },
                ],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: EasymdeConfig }, { type: ɵngcc0.NgZone }]; }, { onChange: [{
            type: Output
        }], onBlur: [{
            type: Output
        }], style: [{
            type: Input
        }], delay: [{
            type: Input
        }], disabled: [{
            type: Input
        }], con: [{
            type: ViewChild,
            args: ['easyMarkDownEditor']
        }], options: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EasymdeModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [EasymdeComponent],
                exports: [EasymdeComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EasymdeModule, { declarations: function () { return [EasymdeComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [EasymdeComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { EasymdeComponent, EasymdeConfig, EasymdeModule };

